import React from 'react';
import { Table, Tag } from 'antd';
import TickerChip from "../../Components/TickerChip";
import {CLUSTER_COLORS} from "../../utils/colorUtils";
import {useScreenWidth} from "../../Hooks/useScreen";

const mergeFeatureRankingsAndInfoResults = (featureRankings, infoResults) => {
  const labels = Object.keys(featureRankings.Final_Score);
  return labels.map(label => {
    const infoResult = infoResults.find(result => result.label === label);
    return {
      key: label,
      ticker: label,
      Avg_Correlation: featureRankings.Avg_Correlation[label],
      Cluster_Selected: featureRankings.Cluster_Selected[label],
      Final_Score: featureRankings.Final_Score[label],
      PCA_Importance: featureRankings.PCA_Importance[label],
      individual_mv_dist_corr: infoResult?.individual_mv_dist_corr || 0,
      individual_mv_dist_corr_norm: infoResult?.individual_mv_dist_corr_norm || 0,
      info_content_score: infoResult?.info_content_score || 0,
      info_ratio: infoResult?.info_ratio || 0,
      info_ratio_norm: infoResult?.info_ratio_norm || 0,
      multiple_corr: infoResult?.multiple_corr || 0,
      multiple_corr_norm: infoResult?.multiple_corr_norm || 0,
      partial_corr: infoResult?.partial_corr || 0,
      partial_corr_norm: infoResult?.partial_corr_norm || 0,
    };
  });
};


const FeatureRankTable = ({ featureRankings, infoResults, tickers }) => {
  const dataSource = mergeFeatureRankingsAndInfoResults(featureRankings, infoResults);
  const screenWidth = useScreenWidth();
  const columns = [
    {
      title: 'Ticker',
      dataIndex: 'ticker',
      key: 'ticker',
      render: (ticker) => <TickerChip ticker={tickers.find(x => x.symbol === ticker)} />,
      fixed: 'left'
    },
    {
      title: 'Final Score',
      dataIndex: 'Final_Score',
      key: 'Final_Score',
      sorter: (a, b) => a.Final_Score - b.Final_Score,
      render: (value) => `${(value * 100).toFixed(1)}%`,
      fixed: 'left'
    },
    {
      title: 'Avg Correlation',
      dataIndex: 'Avg_Correlation',
      key: 'Avg_Correlation',
      render: (value) => `${(value * 100).toFixed(1)}%`,
    },
    {
      title: 'Cluster Selected',
      dataIndex: 'Cluster_Selected',
      key: 'Cluster_Selected',
      render: (value) => <Tag color={CLUSTER_COLORS[parseInt(value)]}>{value}</Tag>

    },
    {
      title: 'PCA Importance',
      dataIndex: 'PCA_Importance',
      key: 'PCA_Importance',
      render: (value) => `${(value * 100).toFixed(1)}%`
    },
    {
      title: 'MV Distance Corr',
      dataIndex: 'individual_mv_dist_corr',
      key: 'individual_mv_dist_corr',
      render: (value) => `${(value).toFixed(1)}`
    },
    {
      title: 'Normalized',
      dataIndex: 'individual_mv_dist_corr_norm',
      key: 'individual_mv_dist_corr_norm',
      render: (value) => `${(value * 100).toFixed(1)}%`
    },
    {
      title: 'Info Content Score',
      dataIndex: 'info_content_score',
      key: 'info_content_score',
      render: (value) => `${(value * 100).toFixed(1)}%`
    },
    {
      title: 'Info Ratio',
      dataIndex: 'info_ratio',
      key: 'info_ratio',
      render: (value) => `${(value * 100).toFixed(1)}%`
    },
    {
      title: 'Normalized',
      dataIndex: 'info_ratio_norm',
      key: 'info_ratio_norm',
      render: (value) => `${(value * 100).toFixed(1)}%`
    },
    {
      title: 'Multiple Corr',
      dataIndex: 'multiple_corr',
      key: 'multiple_corr',
      render: (value) => `${(value * 100).toFixed(1)}%`
    },
    {
      title: 'Normalized',
      dataIndex: 'multiple_corr_norm',
      key: 'multiple_corr_norm',
      render: (value) => `${(value * 100).toFixed(1)}%`
    },
    {
      title: 'Partial Corr',
      dataIndex: 'partial_corr',
      key: 'partial_corr',
      render: (value) => `${(value * 100).toFixed(1)}%`
    },
    {
      title: 'Normalized',
      dataIndex: 'partial_corr_norm',
      key: 'partial_corr_norm',
      render: (value) => `${(value * 100).toFixed(1)}%`
    }
  ];

  console.log(screenWidth)

  return (
      <div>
        <Table
          columns={columns}
          dataSource={dataSource}
          pagination={false}
          rowKey="key"
          scroll={{ x: screenWidth-(screenWidth*0.5)}}
        />
      </div>
  );
};

export default FeatureRankTable;